import { type VoidFunctionComponent } from 'react';
import Flex from '../../../generic/Flex';
import SBOMAnalysisSection from './SBOMAnalysisSection';
import useSBOMAnalysis from './useSBOMAnalysis';
import styles from './SBOMAnalysis.module.less';

export enum SBOMAnalysisCategory {
  FILE = 'file',
  REQUIRED_FIELDS = 'requiredFields',
  DEPENDENCY_SCAN = 'dependencyScan',
}

type SBOMAnalysisProps = {
  projectLocator: string,
  revisionId: string,
  revisionBaseUrl: string,
};

const SBOMAnalysisComponent: VoidFunctionComponent<SBOMAnalysisProps> = ({
  projectLocator,
  revisionId,
  revisionBaseUrl,
}) => {
  const {
    isLoading,
    data,
  } = useSBOMAnalysis(
    `${projectLocator}$${revisionId}`,
  );

  if (!data || isLoading) {
    return null;
  }

  return (
    <Flex direction="column" align="start" gap={24}>
      <div className={styles.containerTitle} data-testId="sbom-analysis-title">Analysis</div>
      <SBOMAnalysisSection
        category={SBOMAnalysisCategory.FILE}
        data={data.sbomFile}
        testId="sbom-analysis-section-file"
      />
      <SBOMAnalysisSection
        category={SBOMAnalysisCategory.REQUIRED_FIELDS}
        data={data.requiredFields}
        testId="sbom-analysis-section-required-fields"
      />
      <SBOMAnalysisSection
        category={SBOMAnalysisCategory.DEPENDENCY_SCAN}
        data={data.dependencyScan}
        revisionBaseUrl={revisionBaseUrl}
        testId="sbom-analysis-section-dependency-scan"
      />
    </Flex>
  );
};

export default SBOMAnalysisComponent;
